import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from '../../../base.component';

@Component({
  selector: 'upper-section-dr',
  templateUrl: './upper-section-dr.component.html',
  styleUrls: ['./upper-section-dr.component.scss']
})
export class UpperSectionDrComponent extends BaseComponent implements OnInit {
  isRenters: boolean;

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    this.isRenters = this.storeService.getGlobalAttributes() &&
                     this.storeService.getGlobalAttributes().mpq3DrRentersUiAdjustments;
  }

}
